import React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "./cn";

/** Port of the reference's Alert (src/components/ui/Alert.tsx). No test in
 * the reference — Alert.test.tsx below is authored, not ported. */
const alertVariants = cva("rounded-lg border px-4 py-3 text-sm", {
  variants: {
    variant: {
      error:
        "bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-800 text-red-700 dark:text-red-300",
      success:
        "bg-green-50 dark:bg-green-950 border-green-200 dark:border-green-800 text-green-700 dark:text-green-300",
      warning:
        "bg-amber-50 dark:bg-amber-950 border-amber-200 dark:border-amber-800 text-amber-700 dark:text-amber-300",
      info: "bg-blue-50 dark:bg-blue-950 border-blue-200 dark:border-blue-800 text-blue-700 dark:text-blue-300",
    },
  },
  defaultVariants: {
    variant: "error",
  },
});

interface AlertProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertVariants> {
  children: React.ReactNode;
}

function Alert({
  variant,
  role = "alert",
  className,
  children,
  ...props
}: AlertProps) {
  return (
    <div role={role} className={cn(alertVariants({ variant }), className)} {...props}>
      {children}
    </div>
  );
}

export { Alert, alertVariants };
export type { AlertProps };
